<template>
  <v-row dense>
    <v-col>
      <v-card flat>
        <v-card-text class="px-3 pt-2 pb-1">
          <DataListHeading
            label="Стан бази даних"
            :search-field="false"
            :loading="loading"
            :divider="false"
            disabled
          />
          <v-row>
            <v-col>
              <v-menu
                offset-y
                bottom
                :close-on-click="updateLoading ? false : true"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Аналіз
                  </v-btn>
                </template>
                <v-card style="width: 400px; max-width: 800px; height: 400px;">
                  <v-card-text
                    class="px-3 pt-2 pb-1"
                    style="height: 85%; overflow-y: auto"
                  >
                    <v-data-table
                      :items="analysis"
                      :headers="analysisHeaders"
                      :items-per-page="analysis.length"
                      :loading="updateLoading"
                      hide-default-footer
                      disable-sort
                      no-data-text="Дані відсутні"
                      loading-text="Завантаження данних"
                    >
                      <template v-slot:item="{ item }">
                        <tr>
                          <td style="height:36px">
                            {{ item.lastBalanceDate | date }}
                          </td>
                          <td style="height:36px">
                            {{ item.title }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions class="d-flex flex-row-reverse">
                    <v-btn
                      :loading="updateLoading"
                      @click="updateAnalysisBalances"
                    >
                      Перерахувати
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <ModalLoader
                title="Виконується перерахування"
                :loading="updateLoading"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h2 class="subtitle-1 font-weight-medium mx-1 mr-4">
                Працівники без грейду
              </h2>
              <v-data-table
                :items="employees"
                :headers="headersOfEmployeeList"
                :items-per-page="employees.length"
                hide-default-footer
                disable-sort
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="height:36px">
                      {{ item.title }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col>
              <h2 class="subtitle-1 font-weight-medium mx-1 mr-4">
                Проекти без клієнта
              </h2>
              <v-data-table
                :items="projects"
                :headers="headersOfProjectList"
                :items-per-page="projects.length"
                hide-default-footer
                disable-sort
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="height:36px">
                      {{ item.title }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DataListHeading from "../../components/DataListHeading.vue";
import ModalLoader from "../../components/ModalLoader.vue";
import * as settingsApi from "../../backend/settingsApi.js";

export default {
  components: {
    DataListHeading,
    ModalLoader,
  },
  data: () => ({
    employees: [],
    projects: [],
    loading: false,
    updateLoading: false,
    headersOfEmployeeList: [
      {
        text: "Ім'я",
        align: "left",
        value: "title",
      },
    ],
    headersOfProjectList: [
      {
        text: "Назва",
        align: "left",
        value: "title",
      },
    ],
    analysis: [],
    analysisHeaders: [
      { text: "Дата", value: "lastBalanceDate" },
      { text: "Клієнт", value: "title" },
    ],
  }),
  computed: {
    minAnalysisDate() {
      return this.analysis.map(a => a.lastBalanceDate).sort((a,b) => new Date(a) - new Date(b))[0];
    },
    minDate() {
      return this.moment().subtract(2, "years").endOf("year").format();
    },
  },
  created() {
    this.getReportsCheck();
    this.getAnalysisBalances();
  },
  methods: {
    async getReportsCheck() {
      this.loading = true;
      const response = await settingsApi.getReportsCheck();
      this.employees = response.employeesWithoutGrade;
      this.projects = response.projectsWithoutClients;
      this.loading = false;
    },
    async getAnalysisBalances() {
      this.loading = true;
      const response = await settingsApi.getAnalysisClientBalances();
      this.analysis = response;
      this.loading = false;
    },
    async updateAnalysisBalances() {
      this.loading = true;
      const date = this.minAnalysisDate ? this.moment(this.minAnalysisDate).format() : this.minDate;
      await settingsApi.updateAnalysisClientBalances(date);
      this.loading = false;
      this.updateLoading = false;
      this.getAnalysisBalances();
    },
  },
};
</script>
